(() => {
  let activeDialog = null;
  let returnFocus = null;
  let previousOverflow = '';
  let inertSiblings = [];
  const focusableSelector = 'a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])';
  const focusableElements = () => [...activeDialog.querySelectorAll(focusableSelector)]
    .filter(element => element.getClientRects().length && getComputedStyle(element).visibility !== 'hidden' && !element.closest('[inert]'));

  function closeDialog() {
    if (!activeDialog) return;
    const dialog = activeDialog;
    activeDialog = null;
    dialog.classList.remove('show');
    dialog.classList.add('hidden');
    dialog.hidden = true;
    dialog.setAttribute('aria-hidden', 'true');
    if (returnFocus) returnFocus.setAttribute('aria-expanded', 'false');
    inertSiblings.forEach(([element, wasInert]) => { element.inert = wasInert; });
    inertSiblings = [];
    document.body.style.overflow = previousOverflow;
    if (returnFocus?.isConnected) returnFocus.focus({ preventScroll: true });
    returnFocus = null;
  }

  function openDialog(opener) {
    const dialog = document.getElementById(opener.getAttribute('aria-controls'));
    if (!dialog?.matches('[data-nutracene-ingredients-dialog]')) return;
    closeDialog();
    returnFocus = opener;
    activeDialog = dialog;
    previousOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    dialog.hidden = false;
    dialog.classList.remove('hidden');
    dialog.classList.add('show');
    dialog.setAttribute('aria-hidden', 'false');
    opener.setAttribute('aria-expanded', 'true');
    // Make only the dialog's ancestor path available while it is open.
    let branch = dialog;
    while (branch.parentElement && branch !== document.body) {
      [...branch.parentElement.children].forEach(sibling => {
        if (sibling === branch || ['SCRIPT', 'STYLE', 'LINK'].includes(sibling.tagName)) return;
        inertSiblings.push([sibling, sibling.inert]);
        sibling.inert = true;
      });
      branch = branch.parentElement;
    }
    dialog.scrollTop = 0;
    const content = dialog.querySelector('.popup-content');
    if (content) content.scrollTop = 0;
    (dialog.querySelector('[data-nutracene-ingredients-close]') || dialog).focus({ preventScroll: true });
  }

  document.addEventListener('click', event => {
    const opener = event.target.closest('[data-nutracene-ingredients-open]');
    if (opener) {
      event.preventDefault();
      openDialog(opener);
      return;
    }
    if (activeDialog && (event.target === activeDialog || event.target.closest('[data-nutracene-ingredients-close]'))) {
      event.preventDefault();
      closeDialog();
    }
  });

  document.addEventListener('keydown', event => {
    if (!activeDialog) return;
    if (event.key === 'Escape') {
      event.preventDefault();
      event.stopImmediatePropagation();
      closeDialog();
    } else if (event.key === 'Tab') {
      const elements = focusableElements();
      const first = elements[0] || activeDialog;
      const last = elements[elements.length - 1] || activeDialog;
      if (!elements.length || !activeDialog.contains(document.activeElement) ||
          (event.shiftKey && (document.activeElement === first || document.activeElement === activeDialog)) ||
          (!event.shiftKey && (document.activeElement === last || document.activeElement === activeDialog))) {
        event.preventDefault();
        (event.shiftKey ? last : first).focus();
      }
    }
  }, true);

  document.addEventListener('focusin', event => {
    if (activeDialog && !activeDialog.contains(event.target)) {
      (focusableElements()[0] || activeDialog).focus({ preventScroll: true });
    }
  });

  document.addEventListener('shopify:section:unload', event => {
    if (activeDialog && event.target.contains(activeDialog)) closeDialog();
  });
})();